// Export public route definitions that don't require authentication
export const PUBLIC_ROUTE_PREFIXES = [
  "/auth/",
  "/blogs",
  "/decrypt",
  "/p/",
  "/payment/",
  "/common/collection/",
  "/content-policy-and-child-protection",
  "/legal-notices",
  "/contact",
  "/general-conditions-of-sale",
  "/general-conditions-of-use",
  "/confidentiality-and-data-protection",
  //"/sebyvsstrongui",
  "/profiles",
  "/tracking",
  "/tracking-links",
  "/", // Home page (exact match)
];

export const isPublicRoute = (path: string): boolean => {
  if (path === "/") return true;

  return PUBLIC_ROUTE_PREFIXES.some((prefix) => {
    if (prefix === "/") return false; // Skip home page in prefix check
    return path.startsWith(prefix);
  });
};
